import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getRankTaskInfo = createAsyncThunk(
  'rankTask/getRankTaskInfo',
  async ({rank_type}: {rank_type: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rank_task_list', {
      ...store.getState().env.deviceinfo,
      rank_type,
    })
    return resp.data
  }
)
interface itemProp {
  member: any
  rank_no: number | string
  score: number
  is_show: boolean
  data?: number
}
const initialState: {
  list: Array<itemProp>
  activity_expire: number
  own: itemProp
  score: number
  rank_type: number
} = {
  list: [],
  activity_expire: 0,
  own: {
    member: {},
    rank_no: '',
    score: 0,
    is_show: false,
  },
  score: 0,
  rank_type: 1, // 1 主播榜， 2，supporter榜
}

export const rankTastSlice = createSlice({
  name: 'rankTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRankTaskInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})
export default rankTastSlice.reducer
